var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield_fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.468 1.46333L13.1347 3.21333C13.3889 3.30862 13.6079 3.47924 13.7626 3.70237C13.9172 3.9255 14 4.19052 14 4.462V8.03733C14 9.15162 13.6898 10.2439 13.104 11.1918C12.5182 12.1396 11.68 12.9057 10.6833 13.404L8.44733 14.5213C8.30845 14.5908 8.15529 14.627 8 14.627C7.84471 14.627 7.69155 14.5908 7.55267 14.5213L5.31667 13.4033C4.32003 12.905 3.48184 12.139 2.89605 11.1911C2.31025 10.2432 1.99998 9.15095 2 8.03667V4.46267C1.99983 4.19108 2.0826 3.92591 2.23725 3.70264C2.39189 3.47938 2.61102 3.30866 2.86533 3.21333L7.532 1.46333C7.83375 1.35022 8.16625 1.35022 8.468 1.46333ZM8 5.33333C7.83671 5.33335 7.67911 5.3933 7.55708 5.50181C7.43506 5.61032 7.3571 5.75983 7.338 5.922L7.33333 6V7.33333H6C5.83008 7.33352 5.66664 7.39859 5.54309 7.51523C5.41953 7.63188 5.34518 7.7913 5.33522 7.96093C5.32526 8.13056 5.38045 8.29759 5.48951 8.42789C5.59857 8.55819 5.75327 8.64193 5.922 8.662L6 8.66667H7.33333V10C7.33352 10.1699 7.39859 10.3334 7.51523 10.4569C7.63188 10.5805 7.7913 10.6548 7.96093 10.6648C8.13056 10.6747 8.29759 10.6196 8.42789 10.5105C8.55819 10.4014 8.64193 10.2467 8.662 10.078L8.66667 10V8.66667H10C10.1699 8.66648 10.3334 8.60141 10.4569 8.48477C10.5805 8.36812 10.6548 8.2087 10.6648 8.03907C10.6747 7.86944 10.6196 7.70241 10.5105 7.57211C10.4014 7.44181 10.2467 7.35807 10.078 7.338L10 7.33333H8.66667V6C8.66667 5.82319 8.59643 5.65362 8.4714 5.5286C8.34638 5.40357 8.17681 5.33333 8 5.33333Z",
    fill: "#ECF6FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsurance);
export default __webpack_public_path__ + "static/media/icon-insurance.2d63554f717e4345d2317fddc1be8362.svg";
export { ForwardRef as ReactComponent };